import useAuth from "hooks/useAuth";
import moment from "moment-timezone";

export const flattenErrors = (obj, prefix = "") => {
  const errors = {};
  for (const key in obj) {
    const value = obj[key];
    const path = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === "string") {
      errors[path] = value;
    } else if (Array.isArray(value)) {
      // If it's an array of strings, take the first one
      if (value.length > 0 && typeof value[0] === "string") {
        errors[path] = value[0]; // or join them with `value.join(', ')` if needed
      }
    } else if (typeof value === "object" && value !== null) {
      Object.assign(errors, flattenErrors(value, path));
    }
  }
  return errors;
};

export const formatDateWithFormat = (date, format) => {
  if (!date) return null;
  const { user } = useAuth();
  if (user?.timezone) {
    return moment(date).tz(user.timezone).format(format);
  }
  return moment(date).format(format);
};

export const formatDateWithFormatForJobData = (payload, format) => {
  const parsed_payload = typeof payload === "string" ? JSON.parse(payload) : payload;
  // Create a deep copy to avoid mutating the original data
  const deepCopy = JSON.parse(JSON.stringify(parsed_payload));

  // Recursive function to traverse and convert timestamps
  const convertTimestamps = (obj) => {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => convertTimestamps(item));
    }

    const result = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        // Check if this is a timestamp field
        if (key === "start_date_timestamp" || key === "end_date_timestamp") {
          const dateValue = value;

          // Check if it's already a formatted string (contains non-numeric characters)
          if (typeof dateValue === "string" && /[^0-9]/.test(dateValue)) {
            // Already formatted, use as is
            const dateKey = key.replace("_timestamp", "");
            result[dateKey] = dateValue;
            // Don't copy the timestamp field
          } else {
            // Parse as timestamp
            const dateMs = typeof dateValue === "string" ? parseInt(dateValue, 10) : dateValue;
            if (!isNaN(dateMs) && dateMs > 0) {
              // Convert to readable format
              const dateKey = key.replace("_timestamp", "");
              result[dateKey] = format ? moment(dateMs).format(format) : moment(dateMs).format();
            } else {
              // Invalid timestamp, keep original value
              result[key] = value;
            }
          }
        } else {
          // Recursively process nested objects and arrays
          result[key] = convertTimestamps(value);
        }
      }
    }

    return result;
  };

  return convertTimestamps(deepCopy);
};
